//NOTE because this has a pop up menu => it is client component
'use client';

import { ShoppingCart } from '@/lib/db/cart';
import Link from 'next/link';
import { DropdownMenu, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { ShoppingCart as ShoppingIcon } from 'lucide-react';
import { Badge } from '../ui/badge';

// ─── Type ─────────────────────────────────────────── 🟩 ─

interface ShoppingCartButtonProps {
  cart: ShoppingCart | null;
}

// ─── Comp ─────────────────────────────────────────── 🟩 ─

const ShoppingCardButton = ({ cart }: ShoppingCartButtonProps) => {
  /* Close Shopping Cart ------------ */
  const closeDropdown = () => {
    const el = document.activeElement as HTMLElement;
    if (el) {
      el.blur();
    }
  };
  // ─────────────────────────────────────────────────────────

  return (
    <Link href="/cart">
      <DropdownMenu>
        <DropdownMenuTrigger className=" p-3 hover:shadow-lg duration-300  rounded-full mr-4 border-zinc-200 border-2 ">
          <div className="flex relative items-center ">
            <ShoppingIcon />
            {cart?.size > 0 && (
              <Badge className="absolute left-4 text-xs bottom-4">
                {cart?.size}
              </Badge>
            )}
          </div>
        </DropdownMenuTrigger>
      </DropdownMenu>
    </Link>
  );
};
export default ShoppingCardButton;
